import config from '../config';
import {axios} from '../libs';
import iam from '@vht/cloud-services-iam';

let _setIdentityContext;
let _initialized = false;

const _self = {
  setUpdateHandler(setIdentityContext) {
    _setIdentityContext = setIdentityContext;
  },

  async changeOrganization(organizationId) {
    await axios.post(`${config.platformManagement.apiUrl}/switch_organization`, {id: organizationId});
    window.location.reload();
  },

  async initialize() {
    const iamConfig = {
      baseUrl: process.env.PUBLIC_URL,
      platformManagementApiUrl: config.platformManagement.apiUrl,
    };

    if (config.auth0) {
      iamConfig.auth0 = {
        domain: config.auth0.domain,
        client_id: config.auth0.clientId,
        audience: config.auth0.audience,
      };
    }

    _initialized = await iam.initialize(iamConfig);
    return _initialized;
  },

  async reloadUser() {
    await iam.reloadUser();
    _setIdentityContext(_self.getContext());
  },

  getContext() {
    if (_initialized) {
      return {
        isAuthenticated: iam.isAuthenticated,
        user: iam.user,
        login: iam.login,
        forceInteractiveLogin: iam.forceInteractiveLogin,
        getToken: iam.getToken,
        logout: iam.logout,
        reloadUser: _self.reloadUser,
        changeOrganization: _self.changeOrganization,
        can: iam.can,
      };
    }

    return {
      isAuthenticated: false,
      user: undefined,
      login: () => {},
      forceInteractiveLogin: () => {},
      getToken: () => {
        return undefined;
      },
      logout: () => {},
      reloadUser: _self.reloadUser,
      changeOrganization: _self.changeOrganization,
    };
  },
};

export default _self;
